export default "__VITE_ASSET__C2bE_4CW__"